class ELKFormatter {
    appEnv;
    // oxlint-disable-next-line typescript/parameter-properties
    constructor(appEnv) {
        this.appEnv = appEnv;
    }
    format(log) {
        const elkAppInfo = {
            runtime: 'browser',
            application: this.appEnv.application,
            mcs_run_env: this.appEnv.mcsRunEnv,
            version: this.appEnv.version,
            available_screen_size: this.appEnv.availableScreenSize,
            screen_size: this.appEnv.screenSize,
        };
        return JSON.stringify({ ...elkAppInfo, ...log });
    }
}

export { ELKFormatter };
//# sourceMappingURL=ELKFormatter.js.map
